<template>
  <div class="space-y-4 pb-2">
    <chat-message
      v-for="(message, i) in messages"
      :key="i"
      :message="message"
      :feedback-enabled="feedbackEnabled"
      @focus-sources="$emit('focus-sources')"
      @feedback="$emit('feedback', $event)"
    />

    <!-- Typing indicator -->
    <div
      v-if="typing"
      class="flex items-start gap-2 justify-start"
    >
      <span class="cap-avatar mt-1">
        <img
          src="@/assets/capacio/login/logo-cropped.svg"
          alt=""
          class="cap-bean"
        >
      </span>
      <div class="text-gray-400 px-4 py-3 flex items-center">
        <span class="task-status">{{ task || 'Thinking' }}</span>
        <span class="typing-dots">
          <span class="typing-dot">●</span>
          <span class="typing-dot">●</span>
          <span class="typing-dot">●</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ChatMessage from './ChatMessage.vue'

export default {
  components: { ChatMessage },

  props: {
    messages: {
      type: Array,
      required: true
    },
    typing: {
      type: Boolean,
      default: false
    },
    // What the agent is doing right now (e.g. "Checking player stats"),
    // streamed in from the API — see Chatbot.vue's send()/currentTask.
    task: {
      type: String,
      default: ''
    },
    // Thumbs up/down under saved answers (only when chat saving is on)
    feedbackEnabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
